<template>
  <Sidebar>
    <SidebarHeader>
      <Header />
    </SidebarHeader>
    <SidebarContent>
      <MenuGroups :groups="menuGroups" />
    </SidebarContent>
    <SidebarContent class="justify-end">
      <SidebarGroup class="border-none">
        <MenuItems :items="lowerMenuItems" />
      </SidebarGroup>
    </SidebarContent>
    <SidebarFooter>
      <SignOutButton />
    </SidebarFooter>
  </Sidebar>
</template>

<script setup lang="ts">
import SignOutButton from '@/components/shared/SignOutButton.vue';
import Header from '@/components/shared/sidebar/Header.vue';
import { useMainSidebar } from './useMainSidebar.ts';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from '@/components/ui/sidebar';
import MenuGroups from '@/components/shared/sidebar/MenuGroups.vue';
import MenuItems from '@/components/shared/sidebar/MenuItems.vue';
import SidebarGroup from '@/components/ui/sidebar/SidebarGroup.vue';

const { menuGroups, lowerMenuItems } = useMainSidebar();
</script>
